require('./bootstrap');
require('./bootstrap-table-de-DE-custom');

import { handleGeneralModal, handlePreviewModal } from './modal.js';
import { pdfjs } from './pdf.js';


var baseURL = "";

$(document).ready(function() {

    /**
     *  AJAX setup
     */
    baseURL = $("#baseURL").val();

    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $('meta[name=_token]').attr('content')
        }
    });

    function doAction(actionURL, params, callback){
        var URL = actionURL;
        if(actionURL.indexOf('haspa-signage') === -1 && actionURL.indexOf('haspa-cms') === -1 &&
            actionURL.indexOf('192.168.1.71') === -1 && actionURL.indexOf('192.168.178.1') === -1 &&
            actionURL.indexOf('localhost') === -1 && actionURL.indexOf('127.0.0.1') === -1 && actionURL.indexOf('195.252.156.72') === -1 && actionURL.indexOf('scalalight.test') === -1){
            URL = baseURL+''+actionURL;
        }
        $.ajax({
            url: URL,
            type: "POST",
            processData: false,
            contentType: false,
            data: params,
            success: function(json){
                if(json && $.type(json['session_timed_out']) !== "undefined"){
                    window.location.href = baseURL;
                }
                if($.type(callback) === 'function'){
                    callback(json);
                }
                //hideLoading();
            }
        });
    }

    document.getElementById('loading').style.display = "none";

    // Submit search when clicked on search icon
    $(".preset-search-box i").on('click', function() {
        $(".preset-search-box").submit();
    });

  let datesDisabled = window.datesDisabled ?? null;
  let startDate = window.startDate ?? null;

  // Validity datepicker
  $("#valid-start-date, #valid-end-date").datepicker({
    autoclose: true,
    language: "de",
    format: "dd.mm.yyyy",
    clearBtn: true,
    startDate: startDate,
    datesDisabled: datesDisabled
  });

  // Other datepickers
  $(".ticket-deadline, .registration-deadline, .event-date, .event-end-date").datepicker({
    autoclose: true,
    language: "de",
    format: "dd.mm.yyyy",
    startDate: startDate,
    clearBtn: true
  });
    /**
     *  Show/hide Loading
     */
    var showLoading = function(state){
        if (state) {
            $("#loading").css("height", $(document).height()+"px").show();
        } else {
            $("#loading").hide();
        }
    }

    // Change Filiale for supervisor
    $("#change-filiale").on('change', function() {
        // Set the parameters
        var params = new FormData();
        params.append("filiale_id", $(this).val());
        params.append("referrer", window.location.href);
        // Make the call to the backend
        doAction("/change-filiale", params, function(url){
            // Redirect to the relevant module depending on referrer sent with request
            window.location.href = url;
        });
    });

    // Change role for supervisor and admin
    $("#change-role").on('change', function(){
        // Set the parameters
        var params = new FormData();
        params.append("role", $(this).val());
        // Make the call to the backend
        doAction("/change-role", params, function(url){
            // Redirect to the relevant module depending on referrer sent with request
            window.location.href = url;
        });
    });

    /**
     *  Submit form to save and close
     */
    $(".save-and-close").on('click', function(event){
        event.preventDefault();
        if($("#approval").length > 0){
            $("#approval").prop("checked", false);
        }
        $(this).parents("form").submit();
    });

    /**
     *  Submit form after checking approval checkbox
     */
    $(".save-and-send-approval").on('click', function(event){
        event.preventDefault();
        $("#approval").prop("checked", true);
        $(this).parents("form").submit();
    });

    /**
     *  Go to preview page without saving
     */
    $(".show-preview").on('click', function(event){
        event.preventDefault();
        $("#go-to-preview").prop("checked", true);
        $(this).parents("form").submit();
    });

    /**
     *  Show loading
     */
     $(".action-buttons button[type='submit'].red-button").on('click', function(){
        showLoading(true);
    });

    /**
     *  Approve  or reject
     */
    $(".approval-form button[type='submit'].red-button").on('click', function(event){
        event.preventDefault();
        if ($(this).hasClass("approve")) {
            $("#approval-state").prop("checked", true);
        }else{
            $("#approval-state").prop("checked", false);
        }
        $(this).parents("form").submit();
    });

    /**
     *  Show preview in the popup
     */
    $(".show-preview-popup").on('click', function(){
        var mod    = $(this).attr("module"),
            id     = $(this).attr("entry_id"),
            prefix = "",
            HTML   = "";

        if(mod === "App\\Models\\FilialeNews"){
            prefix = "FILIALE_NEWS_"+id;
        }else if(mod === "App\\Models\\Campaign"){
            prefix = "CAMPAIGN_"+id;
        }else if(mod === "App\\Models\\MitarbeiterTip"){
            prefix = "MITARBEITER_TIP_"+id;
        }else if(mod === "App\\Models\\MTSimpleVoting"){
            prefix = "SIMPLE_VOTING_"+id;
        }else if(mod === "App\\Models\\MTDetailedVoting"){
            prefix = "DETAILED_VOTING_"+id;
        }else if(mod === "App\\Models\\EmergencyMessage"){
            prefix = "EMERGENCY_"+id;
        }else if(mod === "EVENT"){
            prefix = "EVENT_"+id;
        }

        // Build the HTML
        if(mod === "App\\Models\\MTCampaign") {
          HTML = "<img src='"+baseURL+"/storage/images/previews/MT_CAMPAIGN_"+id+"_preview_1.png'>";
          if(imageExists(baseURL+"/storage/images/previews/MT_CAMPAIGN_"+id+"_preview_2.png"))
            HTML+= "<img src='"+baseURL+"/storage/images/previews/MT_CAMPAIGN_"+id+"_preview_2.png'>";
          if(imageExists(baseURL+"/storage/images/previews/MT_CAMPAIGN_"+id+"_preview_3.png"))
            HTML+= "<img src='"+baseURL+"/storage/images/previews/MT_CAMPAIGN_"+id+"_preview_3.png'>";
          if(imageExists(baseURL+"/storage/images/previews/MT_CAMPAIGN_"+id+"_preview_4.png"))
            HTML+= "<img src='"+baseURL+"/storage/images/previews/MT_CAMPAIGN_"+id+"_preview_4.png'>";
        }
        else if (mod.indexOf("Voting") > -1) {
            HTML+= "<img src='"+baseURL+"/storage/images/previews/"+prefix+"_landscape_preview.png'>";
        } else {
            HTML = "<img src='"+baseURL+"/storage/images/previews/"+prefix+"_portrait_preview.png'>";
            HTML+= "<img src='"+baseURL+"/storage/images/previews/"+prefix+"_landscape_preview.png'>";
        }

        handlePreviewModal();
        var previews = document.getElementById('new_modal-previews');
        previews.innerHTML = HTML;
    });

    /**
     *  Generic confirmation popup
     */
    function ConfirmationPopup(message, URL, location = ""){
        handleGeneralModal();
        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML = message;

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" class="grey-button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'">NEIN</button><button type="button" id="accept_btn">JA</button>';

        document.getElementById('accept_btn').addEventListener("click", function() {
            doAction(URL, {}, function() {
                if(location != "") {
                  window.location.href = location;
                } else {
                  console.log(URL);
                  window.location.href = URL;
                }
            });
        });
    }

    /**
     * Handle Alert
     */
    function handleAlert(message){
        handleGeneralModal();
        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML = message;

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" id="accept_btn" style="margin-top:15px" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'">OK</button>';
    }


    /**
     *  Delete button
     */
    $(".delete-entry").on('click',function(){
        ConfirmationPopup("Möchtest du den Inhalt wirklich löschen?", $(this).attr("url"), window.location.href);
    });


    /**
     *   Archive Voting
     */
    $('.archive-entry').on("click", function(){
        ConfirmationPopup("Möchtest du die Abstimmung archivieren?", $(this).attr('url'), window.location.href);
  });

    /**
     *  Edit the content which had gone for approval
     */
    $(".edit-approval-content").on('click', function(event){
        event.preventDefault();
        // ConfirmationPopup("Das erneute Bearbeiten erfordert eine Zustimmung eines zweiten Mitarbeiters.", $(this).attr("href"), $(this).attr("href"));

        let URL =  $(this).attr("href");

        handleGeneralModal();
        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML = 'Das erneute Bearbeiten erfordert eine Zustimmung eines zweiten Mitarbeiters.';

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" class="grey-button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'" style="margin-bottom:0">ZURÜCK</button> <button type="button" id="accept_btn" style="margin-top:15px" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'">OK</button>';

        document.getElementById('accept_btn').addEventListener("click", function() {
            window.location.href = URL;
        });
    });

    /**
     *  Media Popup
     */
    function setMediaList(response) {
        // Load the data from Scala CM and show the popup
        $("#media-popup #media-list").html(response);
        $('[data-toggle="popover"]').popover();
    }
    // When category or sub category changes, submit form
    $(document).on("change", "#media-popup .main-category select, #media-popup .sub-category select", function(){
        $(".category-container").submit();
    });
    // When form is submitted, submit it via AJAX
    $(document).on("submit", ".category-container", function(e){
        e.preventDefault();
        var form = $(e.target);
        $.post(form.attr("action"), form.serialize(), setMediaList);
    });

    /**
     *  Filiale News
     */
    // Show the media popup
    $(".select-filiale-news-image").on("click", function(){
        // Load the data from Scala CM and show the popup
        $("#media-popup").removeClass("filiale-news-logo-popup").addClass("filiale-news-popup").modal('show');
        if($(this).hasClass('monothema-image')) {
            doAction("/scala/media/all/SB", {}, setMediaList);
        }else{
            doAction("/scala/media/all/STW", {}, setMediaList);
        }
    });

    // When media is selected, hide popup, set media ID and thumbnail
    $(document).on("click", "#media-popup.filiale-news-popup .media-item.scala-image", function(){
        $("#media-popup").modal('hide');
        var media_image = $(this).find(".media-image");
        $(".filiale-news-image-input").val(media_image.attr("media-id"));
        $(".image-placeholder.filiale-news-image").css("background-image", media_image.css("background-image"));
    });

    /**
     *  Detailed Voting
     */
     $(".select-detailed-voting-option").on('click',function(){
        var position = $(this).attr("position");
        // Load the data from Scala CM and show the popup
        $("#media-popup").addClass("detailed-voting-option-popup").attr("position", position).modal('show');
        doAction("/scala/media/images/SB", {}, setMediaList);
    });
    // When media is selected, hide popup, set media ID and thumbnail
    $(document).on("click", "#media-popup.detailed-voting-option-popup .media-item.scala-image", function(){
        $("#media-popup").modal('hide');
        var position    = $("#media-popup.detailed-voting-option-popup").attr("position");
        var media_image = $(this).find(".media-image");
        $(".upload-detailed-voting-option-image-"+position).val("");
        $(".detailed-voting-option-image-"+position).val(media_image.attr("media-id"));
        $(".detailed-voting-option-image-"+position).siblings(".clear-image").show();
        $(".option-"+position+" .image-placeholder-area .image-placeholder").css("background-image", media_image.css("background-image"));
    });

    // Clear the option image, uploaded or Scala image
    $(".clear-image").on("click", function(){
        $(this).siblings("input.option-image-value, input.hidden").val("");
        $(this).parents(".image-placeholder").css("background-image", "");
        $(this).hide();
    });

    /**
     *   Exposes
     */
    $(".expose-file").on("click", function(){
        $(this).siblings("input").click();
    });

    // For generating preview of the loaded PDF using FileReader (HTML5) and PDFjs (Mozilla corp.)
    $(".expose-file-info input").on("change", function(){
        var parentEl = $(this).parent().parent();

        if (this.files && this.files[0]) {
            $(this).siblings("label").html(this.files[0].name);

            if (FileReader && this.files && this.files.length) {
                var fr        = new FileReader(),
                    extension = this.files[0].name.split('.').pop().toLowerCase();

                fr.onload = function(e) {
                    if (['pdf'].indexOf(extension) > -1) {
                        pdfjs.getDocument(e.target.result).promise.then(
                            function getPdf(pdf) {
                                pdf.getPage(1).then(
                                    function getPage(page) {
                                        var scale    = 0.65,
                                            viewport = page.getViewport({ scale: scale });
                                        var outputScale = window.devicePixelRatio || 1;

                                        if ($(parentEl).find("canvas").length === 0) {
                                            $(parentEl).append('<canvas />');
                                        }
                                        var canvas    = $(parentEl).find("canvas").get(0),
                                            context   = canvas.getContext('2d');

                                        canvas.width = Math.floor(viewport.width * outputScale);
                                        canvas.height = Math.floor(viewport.height * outputScale);
                                        canvas.style.width = 403 + "px";
                                        canvas.style.height =  538 + "px";

                                        var renderContext = {
                                            canvasContext: context,
                                            viewport: viewport
                                        };
                                        page.render(renderContext);
                                    }
                                );
                            }
                        );
                    }
                }
                fr.onloadend = function(e){}
                fr.readAsArrayBuffer(this.files[0]);
            }
        }
    });

    /**
     *  Mitarbeiter Tips
     */
    // Show the popup with profile pictures
    $(".select-mitarbeiter-tips-image").on('click',function(){
        // Load the data from Scala CM and show the popup
        $("#media-popup").modal('show');
        doAction("/get-profile-pictures", {}, setMediaList);
    });

    // When media is selected, hide popup, set media ID and thumbnail
    $(document).on("click", ".media-item.profile-picture", function(){
        $("#media-popup").modal('hide');
        var media_image = $(this).find(".media-image");
        $(".mitarbeiter-tips-image").val(media_image.attr("image"));
        $(".mitarbeiter-tips-first-name").val(media_image.attr("first_name"));
        $(".mitarbeiter-tips-last-name").val(media_image.attr("last_name"));
        $(".image-placeholder").css("background-image", media_image.css("background-image"));

        // remove uploaded image if anything
        $(".upload-mitarbeiter-tips-image").val();
    });

    /**
     *   Monothema
     */
    $(".menu-list .menu-item.disabled a").on('click',function(event){
        event.preventDefault();
        event.stopPropagation();
    });
    $(".detailed-voting-popup-trigger").on('click',function(){
        $("#monothema-voting-popup").modal('hide');
    });

    /**
     *  Presets
     */
    if($(".presets-category-container").length > 0){
        // When category or sub category changes, submit form
        $(document).on("change", ".presets-category-container .main-category select, .presets-category-container .sub-category select", function(){
            $(".presets-category-container").submit();
        });
        // When form is submitted, submit it via AJAX
        $(document).on("submit", ".presets-category-container", function(e){
            e.preventDefault();
            var form = $(e.target);
            window.location.href = form.attr("action") + "?" + form.serialize();
        });
    }

    /**
     *   Preview Slideshow
     */
    if($(".preview-slideshow").length > 0){
        var preview_index = 1;
        showPreview(preview_index);

        function movePreview(n) {
            showPreview(preview_index += n);
        }

        function showPreview(n) {
            var slides = document.getElementsByClassName("preview-slide");
            if (n > slides.length) {
                preview_index = 1;
            }
            if (n < 1) {
                preview_index = slides.length;
            }
            for (var i=0; i<slides.length; i++) {
                slides[i].style.display = "none";
            }
            slides[preview_index-1].style.display = "block";

            if (preview_index == 1) {
                $(".show-previous-arrow").hide();
            } else if (preview_index === slides.length) {
                $(".show-next-arrow").hide();
            } else {
                $(".show-previous-arrow, .show-next-arrow").show();
            }
        }
        $(".show-previous-arrow").on('click',function(){
            movePreview(-1);
        });
        $(".show-next-arrow").on('click',function(){
            movePreview(1);
        });
    }

    /**
     *  Events
     */
    if($(".events-form").length > 0) {
      // Event Type selection
      $('input:radio[name="online_event"]').on('change', function(){
        // Filiale event
        if ($('input:radio[name="online_event"][value="0"]').is(':checked')) {
            $('.online-event-warning').hide();

            $('.event-step.online-event, .event-step-error.online-event-error').hide();
            $('.event-step.filiale-event, .event-step-error.filiale-event-error').show();

            if ($('.special-filiale-note').length > 0) {
                $('.special-filiale-note').hide();
            }

            $('.events-container.exclusive-events .max-plus-guest-container').show();

            // Show Entry Type box
            if ($(".event-step.entry-type-step").length > 0) {
                $(".event-step.entry-type-step").show();
            }
        } // Online event
        else if ($('input:radio[name="online_event"][value="1"]').is(':checked')) {
            $('.online-event-warning').show();

            $('.event-step.online-event, .event-step-error.online-event-error').show();
            // If it's special filiale (666) then don't hide Filiale location box
            if ($('.event-step.filiale-event').hasClass('special-filiale')) {
                $('.special-filiale-note').show();
            } else {
                $('.event-step.filiale-event, .event-step-error.filiale-event-error').hide();
            }

            $('.events-container.exclusive-events .max-plus-guest-container').hide();
            $('.events-container.exclusive-events .max-plus-guest').val('0');

            // If address type is not selected, select Filiale Address
            $('input:radio[name="address_type"][value="2"]').prop('checked', true).change();

            // If Telephone is empty, just puit 0
            if ($('.form-control.event-telephone').val() === "") {
                $('.form-control.event-telephone').val("0");
            }

            // If Partner Online Event is selected, hide Entry Type box
            if ($(".event-step.entry-type-step").length > 0 && $('input:radio[name="online_event_partner"][value="1"]').is(':checked')) {
                $('input:radio[name="entry_type"][value="3"]').prop('checked', true).change();
                $(".event-step.entry-type-step").hide();
            }
        }
    });
    $('input:radio[name="online_event"]').change();

    $('.online-event-filiale-note, .online-event-partner-note').hide();

    // Online Event Type/Partner selection
      $('input:radio[name="online_event_partner"]').on('change', function() {
        const onlineEventPartnerValue = $('input:radio[name="online_event_partner"]:checked').val();
        const isHaspaEvent = onlineEventPartnerValue === "0" || onlineEventPartnerValue === "2";
        const isPartnerEvent = onlineEventPartnerValue === "1";

        const $onlineEventElements = $('.event-step.online-event .online-event-code, .event-step.online-event .online-event-password, .event-step.online-event .online-event-telephone-code');
        const $onlineEventLink = $('.online-event-link .form-control-title .bold-headline');
        const $onlineEventCode = $('.online-event-code .form-control-title .bold-headline');
        const $onlineEventPassword = $('.online-event-password .form-control-title .bold-headline');
        const $webexLabel = $('.webex-label');

        if (isHaspaEvent) {
          $onlineEventElements.show();
          $('.online-event-partner-note').hide();
          $('.online-event-filiale-note').show();
          $('.online-event-webex-note').show();

          if (onlineEventPartnerValue === "0") {
            $onlineEventLink.html('Meeting-Link');
            $onlineEventCode.html('Meeting Kennnummer');
            $onlineEventPassword.html('Meeting Passwort');
            $webexLabel.text('Webex Meeting');
          } else {
            $onlineEventLink.html('Event-URL');
            $onlineEventCode.html('Event-Kennnummer');
            $onlineEventPassword.html('Event-Kennwort');
            $webexLabel.text('Webex Event');
          }

          // Show Entry Type box
          if ($(".event-step.entry-type-step").length > 0) {
            $(".event-step.entry-type-step").show();
          }
        } else if (isPartnerEvent) {
          $onlineEventLink.html('Link zum Online-Veranstaltungsangebot des Partners');
          $onlineEventElements.hide();
          $('.event-step.online-event .online-event-code .form-control, .event-step.online-event .online-event-password .form-control, .event-step.online-event .online-event-telephone-code .form-control').val("");
          $('.online-event-filiale-note').hide();
          $('.online-event-partner-note').show();
          $('.online-event-webex-note').hide();
          $('.online-event-link input').attr('readonly', false);

          // Hide Entry Type box
          if ($('input:radio[name="online_event"][value="1"]').is(':checked') && $(".event-step.entry-type-step").length > 0) {
            // Select Free Entry
            $('input:radio[name="entry_type"][value="3"]').prop('checked', true).change();
            $(".event-step.entry-type-step").hide();
          }
        }
    });
    $('input:radio[name="online_event_partner"]').change();
        // Show the media popup
        $(document).on("click", ".select-event-image", function(){
            // Load the data from Scala CM and show the popup
            $("#media-popup").modal('show');
            doAction("/scala/media/images/VAK", {}, setMediaList);
        });

        // When media is selected, hide popup, set media ID and thumbnail
        $(document).on("click", "#media-popup .media-item.scala-image", function(){
            $("#media-popup").modal('hide');
            var media_image = $(this).find(".media-image");
            $("#scala-picture-id").val(media_image.attr("media-id"));
            $(".image-placeholder.event-image").css("background-image", media_image.css("background-image"));
        });

        $('.categories').select2({
          closeOnSelect: false,
        });

        $('.categories').on('select2:selecting', function(e){
            if($(".categories").select2('data').length > 2){
                e.preventDefault();
                handleGeneralModal();

                var headline = document.getElementById('new_modal-headline');
                headline.innerHTML = 'Es können nicht mehr als 3 Kategorien ausgewählt werden.';

                var btn_area = document.getElementById('new_modal-button-area');
                btn_area.innerHTML = '<button type="button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'" style="margin-bottom:0; margin-top: 15px" id="accept_btn">OK</button>';
            }
        });

        // Partner
        $(".partner-checkbox #partner").on('change', function(){
            if($(this).is(":checked")){
                $(".partner-form").css('display', 'flex');
            }else{
                $(".partner-form").css('display', 'none');
            }
        });

        $(".address-type-options input[name='address_type']").on('change', function(){
            var val = parseInt($(".address-type-options input[name='address_type']:checked").val());

            if(val === 1){
                usePartnerAddress();
                $(".custom-address-form").hide();
            }else if(val === 2){
                useFilialeAddress();
                $(".custom-address-form").show();
                $(".custom-address-form input").attr("readonly", true);
            }else{
                $(".custom-address-form").show();
                $(".custom-address-form input").attr("readonly", false);
            }
        });
        // Use partner address
        function usePartnerAddress(){
            $(".custom-address-name").val($(".partner-name").val());
            $(".custom-address-street").val($(".partner-street").val());
            $(".custom-address-zipcode").val($(".partner-zipcode").val());
            $(".custom-address-city").val($(".partner-city").val());
        }
        // Use filiale address
        function useFilialeAddress(){
            $(".custom-address-name").val(filiale_address.name);
            $(".custom-address-street").val(filiale_address.street);
            $(".custom-address-zipcode").val(filiale_address.zipcode);
            $(".custom-address-city").val(filiale_address.city);
            if(filiale_address.district_id !== 0){
                $(".event-district").val(filiale_address.district_id);
            }
        }

        $(".event-entry-type-container .form-radio-input").on('change', function(){
            var val = parseInt($(".event-entry-type-container .form-radio-input:checked").val());

            if(val === 1){
                $(".registration-fields-container").show();
                $(".ticket-price-form").hide();
            }else if(val === 2){
                $(".ticket-price-form").show();
                $(".registration-fields-container").hide();
            }else{
                $(".registration-fields-container, .ticket-price-form").hide();
            }
        });


        $(".partner-checkbox #partner").change();
        $(".address-type-options input[name='address_type']").change();
        $(".event-entry-type-container .form-radio-input").change();

        /**
         *  Disclaimer popup to be shown before social media options are selected
         */
        function showSocialMediaDisclaimer(target) {
            handleGeneralModal();

            var headline = document.getElementById('new_modal-headline');
            headline.innerHTML = 'Hinweis';

            headline.style.color = 'red';
            headline.style.fontSize = '21px';
            headline.style.fontWeight = '700';
            headline.style.textAlign = 'center';
            headline.style.marginBottom = '20px';

            var body_text = document.getElementById('new_modal-body-text');

            body_text.innerHTML = '<p>Nach Freigabe der Veranstaltung wird dein Bewerbungswunsch automatisch an das verantwortliche Team geschickt.</p>';
            body_text.innerHTML +='<p>Das Team prüft deinen Wunsch und meldet sich bei dir.</p>';
            body_text.innerHTML +='<p>Nutze auch unsere anderen lokalen Social Media Formate, um deine Filiale auf den Social Media Kanälen der Haspa zu präsentieren. Diese findest du im</p>';
            body_text.innerHTML +='<p>Intranet/Markt der Möglichkeiten/Wie und wo kann geworben werden/Social Media, Anzeigen, Presse, E-Mail, Logo für Kooperationspartner/Social Media - lokale Formate</p>';

            var btn_area = document.getElementById('new_modal-button-area');
            btn_area.innerHTML = '<button type="button" class="grey-button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'" style="margin-bottom:0">OK</button>';

            $(".social-media-selection > .field-container > .custom-checkbox > input").prop("checked", true).change();
        }

        $(".social-media-selection > .field-container > .custom-checkbox > input").on('click',function(e){
            // e.preventDefault();
            if($(".social-media-selection > .field-container > .custom-checkbox > input").is(":checked")) {
                showSocialMediaDisclaimer();
            } else {
                $(".social-media-selection > .field-container > .custom-checkbox > input").prop("checked", false).change();
            }
        });

        $(".social-media-selection .social-media").on('change', function(){
            if($(this).is(":checked")){
                $(".social-media-options .disabled-overlay").hide();
            }else{
                $(".social-media-options .disabled-overlay").show();
                $(".social-media-options input").prop("checked", false);
            }
        });
        $(".social-media-selection .social-media").change();
    }

    function eventConfirmationPopup(message, URL, return_URL){
        handleGeneralModal();
        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML = message;

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" class="grey-button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'">NEIN</button><button type="button" id="accept_btn">JA</button>';

        document.getElementById('accept_btn').addEventListener("click", function() {
            doAction(URL, {}, function(){
                window.location.href = return_URL;
            });
        });
    }

    // Delete the event
    $(".delete-event").on('click',function(){
        eventConfirmationPopup("Willst du die Veranstaltung wirklich löschen?", $(this).attr("url"), baseURL+"/events");
    });
    // Delete registrationt
    $(document).on("click", ".delete_registration", function(){
        eventConfirmationPopup("Willst du die Anmeldung wirklich löschen?", $(this).attr("url"), baseURL+"/events/"+$(this).attr("event_id")+"/registrations");
    });
    // reopening registrations
    $(".reopen_registrations").on('click',function(){
        eventConfirmationPopup("Willst du die Anmeldung wieder aktivieren?", $(this).attr("url"), baseURL+"/events");
    });
    // closing registrations
    $(".close_registrations").on('click',function(){
        eventConfirmationPopup("Willst du die Veranstaltung wirklich vorzeitig auf \"ausgebucht\" setzen?", $(this).attr("url"), baseURL+"/events");
    });
    // Deactivate event
    $(".deactivate_event").on('click',function(){
        eventConfirmationPopup("Willst du die Veranstaltung deaktivieren?", $(this).attr("url"), baseURL+"/events");
    });
    // Reactivate event
    $(".reactivate_event").on('click',function(){
        eventConfirmationPopup("Willst du die Veranstaltung wieder aktivieren?", $(this).attr("url"), baseURL+"/events");
    });

    // Copy event link
    var copy_text_emails = function(e) {
        e.preventDefault();
        if(e.clipboardData){
            e.clipboardData.setData('text/plain', $("#list_of_users").val());
        }else if(window.clipboardData){
            window.clipboardData.setData('Text', $("#list_of_users").val());
        }
    }

    $(".invitation-email-list").on('click',function() {
        var emails = "";
        $(".collected_emails").each(function(index, el){
            var email = $(el).text().trim();
            if(email !== ""){
                // emails+= email+";";
                emails+= email;
            }
        });
        if(emails !== ""){
            $("#list_of_users").val(emails);
            document.addEventListener('copy', copy_text_emails);
            var copyText = document.querySelector("#list_of_users");
            copyText.select();
            document.execCommand("copy");
            document.removeEventListener('copy', copy_text_emails);
        }
        $(".invitation-email-list").html("E-mailadressen wurden kopiert");

        handleGeneralModal();

        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML = '<b>Hinweis</b><br/><br/>Hier kannst du die E-Mail-Adressen aller Teilnehmer in die Zwischenablage kopieren, um diese dann per Notes anzuschreiben (z.B. bei Veranstaltungsveränderungen).<b>Füge die E-Mail-Adressen ausschließlich in das Feld "Blindkopie" ein </b>(rechte Maustaste > "einfügen") Aus Datenschutzgründen darf die Empfängerzeile nicht genutzt werden. Als Empfängeradresse verwendest du deine eigene Mailadresse. Versende die E-Mail ohne "Speicherung", da die personenbezogenen Daten spätestens nach Ablauf der Veranstaltung gelöscht werden müssen. In SCALA light erfolgt die Löschung der Daten automatisch.<br/><br/><b>Übrigens:</b> Die Teilnehmer erhalten eine Woche vor dem Veranstaltungsdatum automatisch eine Erinnerung per E-Mail.<br><br>';

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" id="accept_btn" style="margin-top: 15px" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'">OK</button>';
    });

    $(".pdf_registration_list").on('click',function(){
        var url = $(this).attr("url");

        handleGeneralModal();

        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML = '<b>Hinweis</b><br/><br/>Hier kannst du die Teilnehmerliste deiner Veranstaltung aufrufen, um sie auszudrucken oder bei Bedarf deinem Partner digital zur Verfügung zu stellen.<br /><br />Bitte beachte dabei die folgenden Hinweise:<br/><ul><li>Verwahre Ausdrucke der Teilnehmerlisten sicher auf und vernichte diese spätestens nach Ablauf der Veranstaltung.</li><li>Wenn du die Teilnehmerliste versenden möchtest, lade die PDF-Datei herunter.</li><li>Alle technischen Vorgaben findest du im Haspa Intranet (Markt der Möglichkeiten/Scala light).</li><li>Der Versand der Datei an den Partner darf nur verschlüsselt per SecureMail erfolgen. Eine Anleitung für den Partner findest du unter https://www.haspa.de/secure-mail-info</li><li>Der Partner und natürlich auch du darfst die Daten nur für Informationen rund um die Veranstaltung nutzen. Ein entsprechender Passus ist in der Vereinbarung, die mit dem Partner getroffen wird, enthalten.</li><li>Spätestens nach Ablauf der Veranstaltung müssen die Dateien und Mailanhänge von dir gelöscht werden. In SCALA light erfolgt die Löschung der Daten automatisch.</li></ul>';

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" id="accept_btn" style="margin-top: 15px">OK</button>';

        document.getElementById('accept_btn').addEventListener("click", function() {
            handleGeneralModal();
            window.open(url, "_blank");
        });
    });

    $(".pdf_plus_list").on('click',function(){
        var url = $(this).attr("url");

        handleGeneralModal();
        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML =
            '<p>HINWEIS:</p>' +
            '<p>Hier kannst du die Druckdateien für die Namensschilder deiner Veranstaltungsteilnehmer aufrufen, um sie auszudrucken.</p>' +
            '<p>Bitte beachte dabei Folgendes:</p>' +
            '<p>Bei mehr als 10 Teilnehmern erhältst du mehrere Druckdateien. Bitte verwende ausschließlich für die Namenschilder den Namensschild-Bogen. Details hierzu findest du im Markt der Möglichkeiten.</p>' +
            '<p>Verwahre die Ausdrucke der Namensschilder sicher und vernichte nicht abgeholte Namensschilder spätestens nach Ablauf der Veranstaltung.</p>' +
            '<p>Wenn du die Druckdatei(en) abspeicherst, lösche diese spätestens 4 Tage nach der Veranstaltung. In Scala light erfolgt die Löschung der Daten automatisch.</p>';
        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" id="accept_btn" style="margin-top: 15px">OK</button>';

        document.getElementById('accept_btn').addEventListener("click", function() {
            handleGeneralModal();
            window.open(url, "_blank");
        });
    });

    // Delete PlusGuest
    $(document).on("click", ".delete_plus_guest", function(){
        var URL = $(this).attr("url");

        handleGeneralModal();

        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML = 'Willst du die Begleitperson wirklich löschen?';

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" class="grey-button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'" style="margin-bottom:0">NEIN</button><button type="button" id="accept_btn">LÖSCHEN</button>';

        document.getElementById('accept_btn').addEventListener("click", function() {
            doAction(URL, {}, function(returnURL){
                window.location.href = baseURL+returnURL;
            });
        });
    });

    // Copy event link
    var copy_text_event = function(e){
        e.preventDefault();
        if(e.clipboardData){
            e.clipboardData.setData('text/plain', $(".copy_event_link").val());
        }else if(window.clipboardData){
            window.clipboardData.setData('Text', $(".copy_event_link").val());
        }
    };
    $(".event_link_label").on('click',function(){
        document.addEventListener('copy', copy_text_event);
        $(".copy_event_link").val($(this).attr('url'));
        var copyLink = document.querySelector(".copy_event_link");
        copyLink.select();
        document.execCommand("copy");
        $(this).html("Veranstaltungslink wurde kopiert").addClass("copied");
        document.removeEventListener('copy', copy_text_event);
    });
    // Copy event link
    var copy_text_events = function(e){
        e.preventDefault();
        if(e.clipboardData){
            e.clipboardData.setData('text/plain', $(".copy_events_link").val());
        } else if(window.clipboardData){
            window.clipboardData.setData('Text', $(".copy_events_link").val());
        }
    };
    $(".events_link_label").on('click',function(){
        document.addEventListener('copy', copy_text_events);
        $(".copy_events_link").val($(this).attr('url'));
        var copyLink = document.querySelector(".copy_events_link");
        copyLink.select();
        document.execCommand("copy");
        $(this).html("Alle Veranstaltungen im Stadtteil wurden kopiert").addClass("copied");
        document.removeEventListener('copy', copy_text_events);
    });

    /**
     *  Exclusive Events
     */
    // Delete the event
    $(".delete-exclusive-event").on('click', function(){
        eventConfirmationPopup("Willst du die Veranstaltung wirklich löschen?", $(this).attr("url"), baseURL+"/exclusive-events");
    });
    // Deactivate event
    $(".deactivate-exclusive-event").on('click',function(){
        eventConfirmationPopup("Willst du die Veranstaltung deaktivieren?", $(this).attr("url"), baseURL+"/exclusive-events");
    });
    // Reactivate event
    $(".reactivate-exclusive-event").on('click',function(){
        eventConfirmationPopup("Willst du die Veranstaltung wieder aktivieren?", $(this).attr("url"), baseURL+"/exclusive-events");
    });

    // Delete registration
    $(document).on("click", ".delete-exclusive-invitation", function(){
        eventConfirmationPopup("Willst du die Anmeldung wirklich löschen?", $(this).attr("url"), baseURL+"/exclusive-events/"+$(this).attr("event_id")+"/invitations");
    });
    // Delete plus guest
    $(document).on("click", ".delete-exclusive-plus-guest", function(){
        eventConfirmationPopup("Willst du die Begleitperson wirklich löschen?", $(this).attr("url"), baseURL+"/exclusive-events/"+$(this).attr("event_id")+"/invitation/"+$(this).attr("invitation_id")+"/plus-guests");
    });







    // Show the media popup
    $(document).on("click", ".select-exclusive-event-image", function(){
        // Load the data from Scala CM and show the popup
        $("#media-popup").addClass('event-image-popup').modal('show');
        // TODO: Change VAK to GVA
        doAction("/scala/media/images/VK", {}, setMediaList);
    });

  $(document).on("click", ".cancel-attended-count", function(){
      $(".edit-attended-count").show();
      $(".attended-count-form").hide();
      $(".attended-count-form .form-control").val(
          parseInt($(".attended-count-value").text())
      );
  });

  $(document).on("click", ".update-attended-count", function(){
      $(".attended-count-form").submit();
  });

  // Save Invitation
  $(document).on("click", ".save-and-goto-plus-guests", function(){
      $("#goto-plus-guests").prop("checked", true);
      $(".invitation-form").submit();
  });

  function sendInvitationEmail() {
      $("#send-email").prop("checked", true);
      $("#goto-plus-guests").prop("checked", false);
      $(".invitation-form").submit();
  }

  // Send Invitation Email
  $(document).on("click", ".send-invitation-email", function(){
      if ($("#invitation-email-popup").length > 0) {
          $("#invitation-email-popup").modal("show");
      } else {
          sendInvitationEmail();
      }
  });
  // Poup
  $(document).on("click", ".popup-save-and-goto-plus-guests", function(){
      $("#invitation-email-popup").modal("hide");

      $("#send-email").prop("checked", false);
      $("#goto-plus-guests").prop("checked", true);
      $(".invitation-form").submit();
  });
  $(document).on("click", ".popup-send-invitation-email", function(){
      $("#invitation-email-popup").modal("hide");

      sendInvitationEmail();
  });

  // When media is selected, hide popup, set media ID and thumbnail
  $(document).on("click", "#media-popup.event-image-popup .media-item.scala-image", function(){
      $("#media-popup").modal('hide');
      var media_image    = $(this).find(".media-image"),
          media_download = media_image.attr("media-download");
          //filename       = media_download.substring(media_download.lastIndexOf('/') + 1);
      $("#event-image").val(media_download);
      $(".image-placeholder.event-image").css("background-image", media_image.css("background-image"));
  });

  // Upload PDF
  $(document).on("click", ".select-new-pdf", function() {
      var input       = $(this).siblings(".pdf-file"),
          filename    = $(this).siblings(".pdf-filename"),
          delete_pdf  = $(this).siblings(".delete-pdf"),
          placeholder = $(this).parents(".pdf-file-block").find(".new-file");

      input.on('change', function(){
          if (this.files && this.files[0]) {
              placeholder.text(this.files[0].name);
              filename.val(this.files[0].name);
              delete_pdf.addClass("show");
          }
      });

      input.click();
  });

  // Clear/Delete PDF
  $(document).on("click", ".delete-pdf", function() {
      var delete_pdf  = $(this),
          select_pdf  = $(this).siblings(".select-new-pdf"),
          parent      = $(this).parents(".pdf-file-block"),
          input       = $(this).siblings(".pdf-file"),
          filename    = $(this).siblings(".pdf-filename"),
          pdf_id      = $(this).siblings(".pdf-id"),
          placeholder = parent.find(".new-file"),
          textarea    = parent.find(".file-title");

      if ($(this).hasClass("show") || $(this).hasClass("active")) {
          var URL = $(this).attr('delete_URL');

            handleGeneralModal();
            var headline = document.getElementById('new_modal-headline');
            headline.innerHTML = "Bist du sicher, dass du das PDF löschen möchtest?";

            var btn_area = document.getElementById('new_modal-button-area');
            btn_area.innerHTML = '<button type="button" class="grey-button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'">NEIN</button><button type="button" id="accept_btn">LÖSCHEN</button>';

            document.getElementById('accept_btn').addEventListener("click", function() {
                doAction(URL, {}, function(URL) {
                    input.val("");
                    filename.val("");
                    textarea.val("");
                    pdf_id.val("");
                    placeholder.text("Keine Datei ausgewählt");
                    delete_pdf.removeClass("active");
                    select_pdf.removeClass("active");
                });
                handleGeneralModal();
            });

      } else {
          input.val("");
          filename.val("");
          textarea.val("");
          placeholder.text("Keine Datei ausgewählt");
      }
  });

  $("#notify-status").on('change', function(){
      if ($(this).is(":checked")) {
          $(".contact-email-container").show();
      } else {
          $(".contact-email").val("");
          $(".contact-email-container").hide();
      }
  });

  $("input:radio[name='signature_source']").on('change', function(){
      if ($('input:radio[name="signature_source"][value="custom"]').is(':checked')) {
          $(".custom-signature-info").show();
      } else {
          $(".custom-signature-info").hide();
      }
  });

  $("input:radio[name='signature_source']").change();
  $("#notify-status").change();

  // Copy Self Invitation Link
  var copy_self_invitation_link = function(e){
      e.preventDefault();
      if(e.clipboardData){
          e.clipboardData.setData('text/plain', $("#self-invite-link-input").val());
      }else if(window.clipboardData){
          window.clipboardData.setData('Text', $("#self-invite-link-input").val());
      }
  };

  $(document).on("click", ".self-invite-link", function(){
      document.addEventListener('copy', copy_self_invitation_link);
      var copyLink = document.querySelector("#self-invite-link-input");
      copyLink.select();
      document.execCommand("copy");
      $(this).text("Link für offene Registrierung wurde kopiert");
      document.removeEventListener('copy', copy_self_invitation_link);
  });

  // Copy Invitation Link
  var copy_invitation_link = function(e){
      e.preventDefault();
      if(e.clipboardData){
          e.clipboardData.setData('text/plain', $("#invitation_link_to_copy").val());
      }else if(window.clipboardData){
          window.clipboardData.setData('Text', $("#invitation_link_to_copy").val());
      }
  };

  $(document).on("click", ".copy-invitation-link.material-icons", function(){
      $(this).hide();
      document.addEventListener('copy', copy_invitation_link);
      $("#invitation_link_to_copy").val($(this).attr('invitation_link'));
      var copyLink = document.querySelector("#invitation_link_to_copy");
      copyLink.select();
      document.execCommand("copy");
      $(this).siblings('.invitation-link-copied.material-icons').show();
      document.removeEventListener('copy', copy_invitation_link);
  });

  $('.select-csv-invitations').on('click', function() {
      $(".upload-invitations-csv").click();
  });

    $(".upload-invitations-csv").on('change', function() {
        if (this.files && this.files[0]) {
            $(".select-invitations-csv").show().find(".file-name").text(this.files[0].name);
        }
    });
    $('.red-button.insert-invitations').on('click', function() {
        $(this).parents("form").submit();
    });
    // Copy Filiale events link
    var copy_text_filiale_events = function(e){
        e.preventDefault();
        if(e.clipboardData){
            e.clipboardData.setData('text/plain', $(".copy_filiale_events_link").val());
        }else if(window.clipboardData){
            window.clipboardData.setData('Text', $(".copy_filiale_events_link").val());
        }
    };
    $(".filiale_events_link_label").on('click', function(){
        document.addEventListener('copy', copy_text_filiale_events);
        $(".copy_filiale_events_link").val($(this).attr('url'));
        var copyLink = document.querySelector(".copy_filiale_events_link");
        copyLink.select();
        document.execCommand("copy");
        $(this).html("Alle Veranstaltungen deiner Filiale wurden kopiert").addClass("copied");
        document.removeEventListener('copy', copy_text_filiale_events);
    });

    // Handle begleitpersonen fields
    $(".create_registration select[name='plus']").on('change', function(){
        var selected_count = parseInt($(this).val()),
            plus_limit     = $(".plus_guest_box").length;
        if(selected_count === 0){
            for(var i=1;i<=plus_limit;i++){
                if($(".plus_guest_box_"+i).is(":visible")){
                    $(".plus_guest_box_"+i).hide();
                    $(".plus_guest_first_name_"+i+", .plus_guest_last_name_"+i).val("");
                }
            }
        }else{
            // Show plus guests fields to the selected count
            for(var i=1;i<=selected_count;i++){
                if($(".plus_guest_box_"+i).is(":hidden")){
                    $(".plus_guest_box_"+i).css({"display": "flex"});
                }
            }
            // Hide the rest and empty the fields
            selected_count+= 1;
            for(var k=selected_count;k<=plus_limit;k++){
                if($(".plus_guest_box_"+k).length > 0){
                    $(".plus_guest_box_"+k).hide();
                    $(".plus_guest_first_name_"+k+", .plus_guest_last_name_"+k).val("");
                }
            }
        }
    });
    if($(".create_registration select[name='plus']").length < 0){
        $(".create_registration select[name='plus']").change();
    }
    // Paging
    $(".page-link.get_page").on('click', function(){
        window.location.href = baseURL+'/events?page='+$(this).attr('page');
    })

    // Generic zoom in for preview
    $(".message-preview").on('click',function(){
        if ($(this).children().length > 0) {
            var preview = $(this).css("backgroundImage").replace('url(','').replace(')','').replace(/\"/gi, ""),
                HTML    = "";
            if ($(this).hasClass("landscape-preview")) {
                HTML = "<img class='landscape-preview-zoomed' src='"+preview+"'/>";
            } else if ($(this).hasClass("portrait-preview")) {
                HTML = "<img class='portrait-preview-zoomed' src='"+preview+"'/>";
            }

            handlePreviewModal();
            var previews = document.getElementById('new_modal-previews');
            previews.innerHTML = HTML;
            previews.className += " preview-zoom-popup";
        }
    });
    /**
     *  REPORTING
     */
    if ($("#report-list").length > 0) {
        // Calendar options in the search
        $("#search-start, #search-end").datepicker({
            clearBtn: true,
            language: "de",
            autoclose: true,
            format: "dd.mm.yyyy"
        }).on('hide', function() {
                var search_start = $("#search-start").val(),
                    search_end   = $("#search-end").val();

                if(search_start !== "" && !moment(search_start, "DD.MM.YYYY", true).isValid()) {
                    $("#search-start").val("").datepicker("clearDates");

                    handleAlert('Ungültiges Datumsformat. Bitte gib das Datum wie folgt ein TT.MM.JJJJ');
                } else if(search_end !== "") {
                    if(!moment(search_end, "DD.MM.YYYY", true).isValid()){
                        $("#search-end").val("").datepicker("clearDates");

                        handleAlert('Ungültiges Datumsformat. Bitte gib das Datum wie folgt ein TT.MM.JJJJ');
                    } else if(search_start === ""){
                        $("#search-end").val("").datepicker("clearDates");

                        handleAlert('Es darf kein Enddatum ohne Startdatum geben. Bitte gib ein Startdatum ein.');
                    } else if(moment.duration(moment(search_end, "DD.MM.YYYY").diff(moment(search_start, "DD.MM.YYYY"))).asDays() < 0){
                        $("#search-end").val("").datepicker("clearDates");

                        handleAlert('Das Enddatum darf nicht vor dem Anfangsdatum liegen.');
                    }
                }
                $("#search-month").val("").datepicker("clearDates");
                manageContextOption();
            }
        );
        $("#search-month").datepicker({
            clearBtn: true,
            language: "de",
            autoclose: true,
            format: "mm.yyyy",
            startView: "months",
            minViewMode: "months"
        }).on('hide', function(){
                $("#search-start, #search-end").val("").datepicker("clearDates");
                manageContextOption();
            }
        );

        $(".get-report").on('click', function(){
            var search_start = $("#search-start").val(),
                search_end   = $("#search-end").val(),
                search_month = $("#search-month").val(),
                report_URL   = baseURL;

            if ($(this).hasClass("event-report")) {
                // Changed: use module_type instead of search_context
                report_URL += "/reports/events?module_type=" + $("#module-type").val();
            } else {
                report_URL += "/reports/general?module_type=" + $("#module-type").val();
            }

            if (search_month !== "") {
                report_URL += "&search_month=" + search_month;
            } else if (search_start !== "") {
                if (search_end !== "") {
                    report_URL += "&search_start=" + search_start + "&search_end=" + search_end;
                } else {
                    handleAlert('Es darf kein Startdatum ohne Enddatum geben. Bitte gib ein Enddatum ein.');
                    return;
                }
            }

            if ($("#filiale-id").length > 0) {
                var filiale_id = $("#filiale-id").val();
                if (filiale_id !== "") {
                    report_URL += "&filiale_id=" + filiale_id;
                }
            }

            window.location.href = report_URL;
        });
    }

    /**
     *  Emergency
     */
    $(document).on("click", ".enable-emergency", function(){
        eventConfirmationPopup("Bist du sicher, dass du die Notfallkommunikation aktivieren möchtest? Dies überschreibt die lfd. Bildschirminhalte aller Filialen.", $(this).attr("url"), baseURL+"/emergency-message");
    });

    $(document).on("click", ".disable-emergency", function(){
        eventConfirmationPopup("Bist du sicher, dass du die Notfallkommunikation deaktivieren möchtest?", $(this).attr("url"), baseURL+"/emergency-message");
    });

    /**
     *  Quiz
     */
    if ($(".quiz-container").length > 0) {
        $(".select-new-image.select-quiz-image").on('click', function(){
            // Load the data from Scala CM and show the popup
            $("#media-popup").addClass("quiz-image-popup").modal('show');
            doAction("/scala/media/images/STW", {}, setMediaList);
        });
        // When media is selected, hide popup, set media ID and thumbnail
        $(document).on("click", "#media-popup.quiz-image-popup .media-item.scala-image", function(){
            $("#media-popup").modal('hide');
            var media_image = $(this).find(".media-image");
            $(".quiz-image-input").val(media_image.attr("media-id"));
            $(".image-placeholder.quiz-image").css("background-image", media_image.css("background-image"));
        });

        /**
         *  Submit form to save and close
         */
        $(".quiz-save-and-close").on('click', function(event){
            event.preventDefault();
            if($("#approval").length > 0){
                $("#approval").prop("checked", false);
            }

            $("#go-next").prop("checked", false);
          $(this).parents("form").submit();
      });

      /**
       *  Submit form after checking approval checkbox
       */
      $(".quiz-save-and-send-approval").on('click', function(event){
          event.preventDefault();
          $("#approval").prop("checked", true);
          $(this).parents("form").submit();
      });

      /**
       *  Go to next step
       */
      $(".quiz-go-to-next-step").on('click', function(){
          event.preventDefault();
          $("#go-next").prop("checked", true);
          $(this).parents("form").submit();
      });
  }

  /**
   *  Popup for active events
   */
  function activeEventConfirmationPopup(callback) {
      handleGeneralModal();
      var headline = document.getElementById('new_modal-headline');
      headline.innerHTML = '<p><b>Hinweis:</b></p><p>Die Veranstaltung ist bereits veröffentlicht. Wenn du fortfährst, wird die Veranstaltung so lange nicht sichtbar, bis du oder ein/e Kollege/in diese erneut freigeben hat.</p><p style="margin-bottom: 0;">Möchtest du fortfahren?</p>';

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" class="grey-button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'">NEIN</button><button type="button" id="accept_btn">JA</button>';

        document.getElementById('accept_btn').addEventListener("click", function() {
            callback();
        });
  }

  // Save and send active event for approval
  $(".save-and-close-active-event").off().on('click', function(event){
      event.preventDefault();

      activeEventConfirmationPopup(function() {
          $("#approval").prop("checked", true);
          $(".events-form").submit();
      });
  });

  // Save and show preview of the active event
  $(".show-preview-active-event").off().on('click', function(event){
      event.preventDefault();

      activeEventConfirmationPopup(function() {
          $("#go-to-preview").prop("checked", true);
          $(".events-form").submit();
      });
  });

  // Statistics
  $(".rating .editable .star").on('click', function() {
      var rating     = $(this).attr("rating"),
          text_input = $(".rating .editable .text-input");

      if (text_input.val() === rating && rating === "1") {
          text_input.val("0");
          $(this).removeClass("starred");
      } else {
          text_input.val(parseInt(rating));

          setRating();
      }
  });

  function setRating() {
      var rating = $(".rating .editable .text-input").val();

      $.each($(".rating .editable .star"), function(index, value) {
          var star    = $(value),
              starred = parseInt(star.attr("rating"));

          if (starred <= rating) {
              star.addClass("starred");
          } else {
              star.removeClass("starred");
          }
      });
  }



    $(".stats-form .action-btns .confirm").on('click', function(event) {
        event.preventDefault();

        $("#stats-confirmation").prop("checked", true);
        $(".stats-form").submit();
    });

    $(".share-steal-preview").on('click', function() {
        doAction($(this).attr('call_URL'), {}, function(HTML) {
            $("#share-steal-preview-popup").html(HTML).modal('show');
        });
    });

    $(".open-qualitize-popup").on('click', function(){
        doAction($(this).attr('call_URL'), {}, function(HTML){
            $("#reviews-popup").html(HTML).modal('show');
        });
    });

    $(document).on("click", ".close-share-steal-preview", function() {
        $("#share-steal-preview-popup").html('').modal('hide');
    });

    $(document).on("click", ".close", function() {
        $("#reviews-popup").html('').modal('hide');
    });



    // Highlights
    $(document).on('click', '#active-events-table .add-highlights, #highlights-table .delete-highlights', function(event) {
        event.preventDefault();

        doAction($(this).attr('href'), {}, function() {
            window.location.href = baseURL + '/highlights';
        });
    });


    var buttons = [].slice.call(document.querySelectorAll('[data-upload]'));
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            document.getElementById('loading').style.display = "block";
        });
    });



    /*
     * REPORTING
    */

    // Calendar options in the search
    $(".stat-filter-area #search-start, .stat-filter-area #search-end").datepicker({
        clearBtn: true,
        language: "de",
        autoclose: true,
        format: "dd.mm.yyyy"
        }).on('hide', function() {
            var search_start = $("#search-start").val(),
                search_end   = $("#search-end").val();

            if (search_start !== "" && !moment(search_start, "DD.MM.YYYY", true).isValid()) {
                $("#search-start").val("").datepicker("clearDates");
                handleAlert('Ungültiges Datumsformat. Bitte gib das Datum wie folgt ein TT.MM.JJJJ');
            } else if (search_end !== "") {
                if (!moment(search_end, "DD.MM.YYYY", true).isValid()){
                    $("#search-end").val("").datepicker("clearDates");
                    handleAlert('Ungültiges Datumsformat. Bitte gib das Datum wie folgt ein TT.MM.JJJJ');
                } else if (moment.duration(moment(search_end, "DD.MM.YYYY").diff(moment(search_start, "DD.MM.YYYY"))).asDays() < 0) {
                    $("#search-end").val("").datepicker("clearDates");
                    handleAlert('Das Enddatum darf nicht vor dem Anfangsdatum liegen.');
                }
            }
        }
    );

    // Event Advertisement
    if ($('.advertise-filiale').length > 0) {
        $('.advertise-filiale').select2({
            closeOnSelect: false
        });

        function updateSelectedFiliale() {
            var data      = $(".advertise-filiale").select2('data'),
                selection = "Bitte wähle die Filialen aus";

            if (data.length > 0) {
                selection = [];

                for (var i=0; i<data.length; i++) {
                    selection.push(data[i].text);
                }

                selection = selection.join(", ");
            }

            $(".filiale-list .select2-selection.select2-selection--multiple").html(selection);
        }

        $('.advertise-filiale').on('select2:select', function(e) {
            updateSelectedFiliale();
        });

        $('.advertise-filiale').on('select2:unselect', function(e) {
            updateSelectedFiliale();
        });

        updateSelectedFiliale();
    }

    // MT Kampagne
  if($(".mtcampaign-form").length > 0) {
    console.log('blabla', $('input:radio[name="information_day"]'))
    // Event Type selection
    $('input:radio[name="information_day"]').on('change', function () {
      // Filiale event
      if ($('input:radio[name="information_day"][value="0"]').is(':checked')) {
        $('.campaign-step.information-day').hide();
      } // Online event
      else if ($('input:radio[name="information_day"][value="1"]').is(':checked')) {
        $('.campaign-step.information-day').show();
      }
    });
    $('input:radio[name="information_day"]').change();
  }

});



function imageExists(image_url){

  var http = new XMLHttpRequest();

  http.open('HEAD', image_url, false);
  http.send();

  return http.status != 404;

}

function countCharacters(element, outputElement, maxLength) {
  const textEntered = element.value.trim(); // Trim whitespace
  const counter = maxLength - textEntered.length;
  outputElement.textContent = `${counter} / ${maxLength}`;
}

document.addEventListener('DOMContentLoaded', () => {
  const maxLengthList = Array.from(document.querySelectorAll('[data-length]'));

  maxLengthList.forEach(el => {
    const maxLength = el.maxLength;
    const textEntered = el.value.trim(); // Trim whitespace
    const currentLength = maxLength - textEntered.length;

    const outputElement = document.createElement('span');
    outputElement.className = "maxlength-feedback";
    outputElement.textContent = `${currentLength} / ${maxLength}`;

    el.parentNode.insertBefore(outputElement, el);

    el.addEventListener('input', () => {
      countCharacters(el, outputElement, maxLength);
    });

    // Initialize the character count on page load
    countCharacters(el, outputElement, maxLength);
  });
});
